import { Injectable } from '@angular/core';
import { MatChipInputEvent } from '@angular/material';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';
import { NotificationService, DataService, LoaderService, ErrorService, EVENTO, TYPEMESSAGE, UtilityService } from "../../../../shared/session/index";
import { SessionInfo } from "../../../../shared/session/SessionInfo";
import { IrolUser } from './../shared/rolUser.model';

@Injectable()
export class RolUserService {
  constructor(private dataService: DataService, private errorService: ErrorService, private notificationService: NotificationService,
    private loaderService: LoaderService, private utilityService: UtilityService, private sessionInfo: SessionInfo) { }

  listarRolUserUrl: string = 'RoleUser/listarPor'
  asignarRolUserUrl: string = 'RoleUser/insertar'
  deleteRolUserUrl: string = 'RoleUser/delete'


  listarRolUser(filtro: string, pageIndex: number, pageSize: number): any {
    let parameters = new HttpParams();
    parameters = parameters.append("pFiltro", String(filtro));
    this.dataService.set(this.listarRolUserUrl);
    return this.dataService.execGetJson(parameters);
  }


  ToggleRolUser(UserID: number, RoleID: number, AplicacionID: number, OfficeID: number, identificador: boolean) {
    let parameters: string;
    parameters = JSON.stringify({
      RoleID: RoleID,
      AplicacionID: AplicacionID,
      UserID: UserID,
      OfficeID: OfficeID
    })
    if (identificador)
      this.dataService.set(this.asignarRolUserUrl);
    else
      this.dataService.set(this.deleteRolUserUrl);


    return this.dataService.execPostJson(parameters);
  }
}






